<template>
  <div class="animated fadeIn">
    <Row>
      <Input size="small" search @on-search="onFilterClick" v-model="keywordFilter" clearable placeholder="名称/联系电话/联系地址"
             style="width: 200px; margin-right: 3px;"></Input>
      <DatePicker size="small" type="daterange" v-model="selectServiceDatetime" placeholder="选择日期"
                  style="margin-right: 3px; width: 200px;"></DatePicker>
      <Button size="small" type="primary" @click="onFilterClick">查询</Button>
      <Dropdown size="small" style="margin-right: 3px" @on-click="DropdownonFilterClick">
        <Button  size="small" type="primary">
<!--          查询-->
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="createDatetime">创建时间</DropdownItem>
          <DropdownItem name="oldServiceDatetime">旧服务到期</DropdownItem>
          <DropdownItem name="receptDatetime">收款时间</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onManualAnalysis">重新分析</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onExportExcel">导出报表</Button>

<!--      <Button type="primary" size="small" style="margin-right: 3px;" @click="renewalOrderConfirmServiceDatetimeModal = true">批量确认到费期</Button>-->
      <Dropdown v-if="orderList.length > 0" size="small" style="margin-right: 3px" @on-click="DropdownonBitchClick">
        <Button  size="small" type="primary">
          批量操作
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="ConfirmServiceDatetime">批量确认到费期</DropdownItem>
          <DropdownItem name="RefuseService">批量拒绝服务</DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <!--<Button type="primary" size="small" style="margin-right: 3px;" @click="addRenewalOrderModal=true">添加续费订单</Button>-->
      <!--<Button type="primary" size="small" @click="onTest">测试</Button>-->
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content" ref="table"
                 :height="tableHeight"
                 @on-sort-change="sortChange" @contextmenu.prevent.native="onTableRightClick($event)"
                 @on-selection-change="onselectionchange">
          </Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>

    <Modal v-model="setDatetimeModal" title="PDF文档证明时间" @on-ok="onexportvehiclecertOk" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>
    <Modal v-model="setVideoDatetimeModal" title="PDF文档视频机证明时间" @on-ok="onOkVideo" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>

    <Modal v-model="setMergencyAlarmModal" title="导出应急报警装置安装证明" @on-ok="onOkMergencyAlarm" ok-text="导出">
      <Form autoComplete="on" class="card-box login-form">
        <Form-item label="地区">
          <Select style="width: 60px;" v-model="certificateArea">
            <Option v-for="item in certificateAreaOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
          </Select>
        </Form-item>
        <Form-item label="安装日期">
          <DatePicker type="date" placeholder="安装日期" style="width: 200px;margin-right: 10px;"
                      v-model="installDatetime"></DatePicker>
        </Form-item>
        <Form-item label="打印日期">
          <DatePicker type="date" placeholder="打印日期" style="width: 200px;margin-right: 10px;"
                      v-model="exportDatetime"></DatePicker>
        </Form-item>
      </Form>
    </Modal>

    <vehicle-info-detail-modal v-model="vehicleInfoDetailModal" :initValue="vehicleInfoDetailId"
                               @on-success="onModifySuccess"></vehicle-info-detail-modal>
    <web-table-columns-modal v-model="webTableColumnsModal" :columnList.sync="columns"
                             :tableName="$options.name" @on-column-update="onColumnUpdate"></web-table-columns-modal>
    <renewal-order-confirm-service-datetime-modal @on-success="onModifySuccess" v-model="renewalOrderConfirmServiceDatetimeModal" :initValue="renewalOrderConfirmServiceDatetimeId" :listValue="orderList"></renewal-order-confirm-service-datetime-modal>
    <renewal-order-refuse-service-modal @on-success="onModifySuccess" v-model="renewalOrderRefuseServiceModal" :initValue="renewalOrderRefuseServiceId" :listValue="orderList"></renewal-order-refuse-service-modal>
    <renewal-order-cancel-modal @on-success="onModifySuccess" v-model="renewalOrderCancelModal" :initValue="renewalOrderCancelId"></renewal-order-cancel-modal>
    <renewal-order-confirm-recept-modal @on-success="onModifySuccess" v-model="renewalOrderConfirmReceptModal" :initValue="renewalOrderConfirmReceptId"></renewal-order-confirm-recept-modal>
    <renewal-order-callback-client-modal @on-success="onModifySuccess" v-model="renewalOrderCallbackClientModal" :initValue="renewalOrderCallbackClientId"></renewal-order-callback-client-modal>
    <renewal-order-confirm-refuse-service-modal @on-success="onModifySuccess" v-model="renewalOrderConfirmRefuseServiceModal" :initValue="renewalOrderConfirmRefuseServiceId"></renewal-order-confirm-refuse-service-modal>
    <renewal-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId" @on-success="onModifySuccess"></renewal-order-change-business-user-modal>
    <renewal-order-add-to-remark-modal v-model="addToRemarkModal" :initValue="addToRemarkId" @on-success="onModifySuccess"></renewal-order-add-to-remark-modal>
    <renewal-to-jt808-serv-combine-modal @on-success="onModifySuccess" v-model="renewalToJt808ServCombineModal" :initValue="renewalToJt808ServCombineModalId" :deviceSource="renewalToJt808ServCombineModalDeviceSource"></renewal-to-jt808-serv-combine-modal>
    <renewal-order-batch-manual-modal v-model="renewalOrderBatchManualModal" :initValue="renewalOrderBatchManualId" @on-success="onModifySuccess"></renewal-order-batch-manual-modal>
  </div>
</template>

<script>

import VehicleInfoDetailModal from '@/view/crm/components/vehicle-info-detail-modal'
import RenewalToJt808ServCombineModal from '@/view/om/components/renewal-to-jt808-serv-combine-modal'
import RenewalOrderConfirmServiceDatetimeModal from '@/view/om/components/renewal-order-confirm-service-datetime-modal'
import RenewalOrderRefuseServiceModal from '@/view/om/components/renewal-order-refuse-service-modal'
import RenewalOrderCancelModal from '@/view/om/components/renewal-order-cancel-modal'
import RenewalOrderConfirmReceptModal from '@/view/om/components/renewal-order-confirm-recept-modal'
import RenewalOrderCallbackClientModal from '@/view/om/components/renewal-order-callback-client-modal'
import RenewalOrderConfirmRefuseServiceModal from '@/view/om/components/renewal-order-confirm-refuse-service-modal'
import RenewalOrderChangeBusinessUserModal from '@/view/om/components/renewal-order-change-business-user-modal'
import RenewalOrderAddToRemarkModal from '@/view/om/components/renewal-order-add-to-remark-modal'
import RenewalOrderBatchManualModal from '@/view/om/components/renewal-order-batch-manual-modal'

// import BusinessNoteDetailModal from '@/view/crm/components/business-note-detail-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import { numberFormat } from '@/libs/numberutil'
import { genURLParams } from '@/libs/urlparamhelper'

export default {
  name: 'usergrouprenewalorders',
  components: {
    VehicleInfoDetailModal,
    RenewalToJt808ServCombineModal,
    RenewalOrderConfirmServiceDatetimeModal,
    RenewalOrderRefuseServiceModal,
    RenewalOrderCancelModal,
    RenewalOrderConfirmReceptModal,
    RenewalOrderCallbackClientModal,
    RenewalOrderConfirmRefuseServiceModal,
    RenewalOrderChangeBusinessUserModal,
    RenewalOrderAddToRemarkModal,
    RenewalOrderBatchManualModal
  },
  data () {
    return {
      // 设置时间
      setDatetimeId: null,
      setDatetimeModal: false,
      setVideoDatetimeModal: false,
      // 应急报警装置安装证明
      setMergencyAlarmModal: false,
      installDatetime: null,
      exportDatetime: null,
      adas: false,
      certificateArea: 1,

      certificateAreaOptions: [
        { label: '中山', value: 1 },
        { label: '江门', value: 2 }
      ],

      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      selectServiceDatetime: [],
      stateFilter: null,
      receptFilter: null,
      fileReadyFilter: null,
      businessUserFilter: null,
      billTypeFilter: null,
      salesChannelFilter: null,
      isfreeFilter: null,
      FilterClickFilter: null,

      // 续费订单转合拼订单
      renewalToJt808ServCombineModal: false,
      renewalToJt808ServCombineModalId: null,
      renewalToJt808ServCombineModalDeviceSource: 1,

      // 追加备注
      addToRemarkModal: false,
      addToRemarkId: null,

      // 指定业务跟进
      changeBusinessUserModal: false,
      changeBusinessUserId: null,

      // 续费订单确认服务期
      renewalOrderConfirmServiceDatetimeModal: false,
      renewalOrderConfirmServiceDatetimeId: null,

      // 续费订单拒绝服务
      renewalOrderRefuseServiceModal: false,
      renewalOrderRefuseServiceId: null,

      // 续费订单作废
      renewalOrderCancelModal: false,
      renewalOrderCancelId: null,

      // 续费订单确认收款
      renewalOrderConfirmReceptModal: false,
      renewalOrderConfirmReceptId: null,

      // 续费订单回访确认拒绝服务
      renewalOrderCallbackClientModal: false,
      renewalOrderCallbackClientId: null,

      // 续费订单停止服务
      renewalOrderConfirmRefuseServiceModal: false,
      renewalOrderConfirmRefuseServiceId: null,

      // 导出证明
      exportVehicleCertModal: false,
      exportVehicleCertId: null,
      exportVehicleCertRenewaled: false,

      // 订单基本信息
      renewalOrderBaseDetailModal: false,
      renewalOrderBaseDetailId: null,

      // 车辆信息
      vehicleInfoDetailModal: false,
      vehicleInfoDetailId: null,

      // 确认收款
      confirmReceptModal: false,
      confirmReceptId: null,

      // 续费订单详细信息
      renewalOrderDetailModal: false,
      renewalOrderDetailId: null,

      // 手动分析续费订单
      renewalOrderBatchManualModal: false,
      renewalOrderBatchManualId: null,

      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      keywordFilter: null,
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,
      // columnsDisplay: [],
      // columnHeaders: [],
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '订单号',
          resizable: true,
          key: 'orderNum',
          sortable: 'custom',
          width: 180
        },
        {
          title: '车辆信息',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 190,
          render: (h, params) => {
            let registrationNum = ''
            let vin = ''
            if (params.row.positioningDeviceInfo.vehicleInfo) {
              registrationNum = params.row.positioningDeviceInfo.vehicleInfo.registrationNum === null ? '无' : params.row.positioningDeviceInfo.vehicleInfo.registrationNum
              vin = params.row.positioningDeviceInfo.vehicleInfo.vin === null ? '无' : params.row.positioningDeviceInfo.vehicleInfo.vin
            }
            return h('div', [
              h('div', '车牌:' + registrationNum),
              h('div', '车架号:' + vin)
            ])
          }
        },
        {
          title: '客户/分组名',
          resizable: true,
          key: 'positioningDeviceInfo.vehicleInfo.vehicleInfoGroupId',
          sortable: 'custom',
          ellipsis: 'true',
          width: 180,
          render: (h, params) => {
            let display = []
            if (params.row.positioningDeviceInfo.vehicleInfo.clientInfo) {
              display.push(h('div', '客户信息:' + params.row.positioningDeviceInfo.vehicleInfo.clientInfo.name + '(' + params.row.positioningDeviceInfo.vehicleInfo.clientInfo.phoneNum + ')'))
            } else {
              display.push(h('div', '客户信息:无'))
            }
            if (params.row.positioningDeviceInfo.vehicleInfo.vehicleInfoGroup) {
              display.push(h('div', '分组:' + params.row.positioningDeviceInfo.vehicleInfo.vehicleInfoGroup.name))
            } else {
              display.push(h('div', '分组:无'))
            }
            return h('div', display)
          }
        },
        {
          title: '终端主机号',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.positioningDeviceInfo.terminalNum)
          }
        },
        {
          title: '终端类型',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          render: (h, params) => {
            return h('div', params.row.positioningDeviceInfo.positioningDeviceModel.name)
          }
        },
        {
          title: '订单状态',
          resizable: true,
          key: 'state',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140,
          filters: [
            { label: '确认续费期', value: 1 },
            { label: '收款', value: 2 },
            { label: '完成', value: 3 },
            { label: '回访', value: 4 },
            { label: '确认停止服务', value: 5 },
            { label: '停止服务', value: 6 },
            { label: '审核', value: 7 },
            { label: '作废', value: 0 },
            { label: '异常', value: -1 }
          ],
          filterMultiple: true,
          filteredValue: [1, 2, 3, 4, 5, 6, 7],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.stateFilter = []
              val.forEach(item => {
                this.stateFilter.push(genQueryParam('state', 'EQ', item))
              })
            } else {
              this.stateFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            let state = params.row.state
            let step = null
            if (params.row.step != null) {
              step = params.row.step.state
            } else {
              step = 1
            }
            if (state === 1) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待确认续费期')
              } else if (step === 2) {
                return h('div', '已确认续费期')
              } else if (step === 3) {
                return h('div', '确认续费期失败')
              }
            } else if (state === 2) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待收款')
              } else if (step === 2) {
                return h('div', '已收款')
              } else if (step === 3) {
                return h('div', '收款失败')
              }
            } else if (state === 3) {
              return h('div', '完成')
            } else if (state === 4) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待回访')
              } else if (step === 2) {
                return h('div', '已回访')
              } else if (step === 3) {
                return h('div', '回访失败')
              }
            } else if (state === 5) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '待确认停止服务')
              } else if (step === 2) {
                return h('div', '已确认停止服务')
              } else if (step === 3) {
                return h('div', '确认停止服务失败')
              }
            } else if (state === 6) {
              return h('div', '停止服务')
            } else if (state === 7) {
              if (step === 0) {
                return h('div', '作废')
              } else if (step === 1) {
                return h('div', '审核中')
              } else if (step === 2) {
                return h('div', '审核通过')
              } else if (step === 3) {
                return h('div', '审核不通过')
              }
            } else if (state === 0) {
              return h('div', '作废')
            } else if (state === -1) {
              return h('div', '异常')
            }
          }
        },
        {
          title: '结果',
          resizable: true,
          tooltip: 'true',
          ellipsis: 'true',
          width: 160,
          render: (h, params) => {
            if (params.row.step != null) {
              if (params.row.step.result) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, params.row.step.result)
              } else {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '无')
              }
            }
          }
        },
        {
          title: '销售渠道',
          resizable: true,
          key: 'salesChannelId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.salesChannelFilter = []
              val.forEach(item => {
                this.salesChannelFilter.push(genQueryParam('salesChannelId', 'EQ', item))
              })
            } else {
              this.salesChannelFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.salesChannel) {
              return h('div', params.row.salesChannel.name)
            }
          }
        },
        {
          title: '订单类型',
          resizable: true,
          key: 'isfree',
          ellipsis: 'true',
          tooltip: 'true',
          width: 110,
          filters: [
            { label: '自费模式', value: 1 },
            { label: '普通免费模式', value: 2 },
            { label: '太好保免费模式', value: 3 }
          ],
          filterMultiple: true,
          filteredValue: [1],
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.isfreeFilter = []
              val.forEach(item => {
                this.isfreeFilter.push(genQueryParam('isfree', 'EQ', item))
              })
            } else {
              this.isfreeFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.isfree == 1) {
              return h('div', '自费模式')
            } else if (params.row.isfree == 2) {
              return h('div', '普通免费模式')
            } else if (params.row.isfree == 3) {
              return h('div', '太好保免费模式')
            } else {
              return h('div', '无')
            }
          }
        },
        {
          title: '上次收款总金额',
          resizable: true,
          key: 'lastTotalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140
        },
        {
          title: '应收总金额',
          resizable: true,
          key: 'totalAmount',
          tooltip: 'true',
          ellipsis: 'true',
          width: 140
        },
        {
          title: '开票类型',
          resizable: true,
          key: 'billType',
          width: 140,
          filters: [
            { label: '增值税发票', value: 1 },
            { label: '增值税专用发票', value: 2 },
            { label: '增值税普通发票', value: 3 },
            { label: '增值税电子专用发票', value: 4 },
            { label: '增值税电子普通发票', value: 5 }
          ],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.billTypeFilter = []
              val.forEach(item => {
                this.billTypeFilter.push(genQueryParam('billType', 'EQ', item))
              })
            } else {
              this.billTypeFilter = null
            }
            this.setPage(1)
          },
          render: (h, params) => {
            let billType = params.row.billType
            if (billType === 1) {
              return h('div', '增值税发票')
            } else if (billType === 2) {
              return h('div', '增值税专用发票')
            } else if (billType === 3) {
              return h('div', '增值税普通发票')
            } else if (billType === 4) {
              return h('div', '增值税电子专用发票')
            } else if (billType === 5) {
              return h('div', '增值税电子普通发票')
            }
          }
        },
        {
          title: '收款',
          resizable: true,
          key: 'receptDatetime',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [
            { label: '未收款', value: 0 },
            { label: '已收款', value: 1 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.receptFilter = genQueryParam('receptDatetime', 'NNULL', null)
              } else {
                this.receptFilter = genQueryParam('receptDatetime', 'EQNULL', null)
              }
            } else {
              this.receptFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.receptDatetime) {
              let d = new Date(params.row.receptDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            } else {
              return h('div', {
                style: {
                  color: 'red'
                }
              }, '未收款')
            }
          }
        },
        {
          title: '旧服务到期时间',
          resizable: true,
          key: 'oldServiceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.oldServiceDatetime) {
              let d = new Date(params.row.oldServiceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '资料状态',
          resizable: true,
          key: 'fileReady',
          ellipsis: 'true',
          tooltip: 'true',
          width: 120,
          filters: [
            { label: '已准备', value: 1 },
            { label: '未准备', value: 0 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              if (val[0] === 1) {
                this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', true)
              } else {
                this.fileReadyFilter = genQueryParam('fileReady', 'EQBOOL', false)
              }
            } else {
              this.fileReadyFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.fileReady) {
              return h('div', '已准备')
            } else {
              return h('div', '未准备')
            }
          }
        },
        {
          title: '服务到期时间',
          resizable: true,
          key: 'serviceDatetime',
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          render: function (h, params) {
            if (params.row.serviceDatetime) {
              let d = new Date(params.row.serviceDatetime)
              return h('div', d.Format('yyyy年MM月dd日'))
            }
          }
        },
        {
          title: '跟进业务员',
          resizable: true,
          key: 'businessUserId',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180,
          filters: [],
          filterMultiple: true,
          filterRemote: (val) => {
            if (val && val.length > 0) {
              this.businessUserFilter = []
              val.forEach(item => {
                this.businessUserFilter.push(genQueryParam('businessUserId', 'EQ', item))
              })
            } else {
              this.businessUserFilter = null
            }
            this.setPage(1)
          },
          render: function (h, params) {
            if (params.row.businessUser) {
              let name = null
              if (params.row.businessUser.realName) {
                name = params.row.businessUser.realName
              } else if (params.row.businessUser.nickName) {
                name = params.row.businessUser.nickName
              } else if (params.row.businessUser.name) {
                name = params.row.businessUser.name
              }
              return h('div', name)
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'remark',
          width: 180
        },
        {
          title: '确认到费期时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 210,
          render: function (h, params) {
            if (params.row.history != null) {
              if (params.row.history.includes("确认服务期:")) {
                let index = params.row.history.indexOf("确认服务期:")
                // console.log(params.row.history.length)
                // console.log(index)
                // console.log(params.row.history)
                // console.log((params.row.history.substring(index-24)).substring(0,20))
                // console.log(params.row.history.substring(10 , index))
                return h('div', (params.row.history.substring(index-24)).substring(0,20))
              }
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 300,
          fixed: 'right',
          render: (h, params) => {
            let display = []

            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.vehicleInfoDetailId = params.row.positioningDeviceInfo.vehicleInfoId
                    this.vehicleInfoDetailModal = true
                  }
                }
              }, '车辆信息')
            )

            if (params.row.state === 6) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>确认重新开通服务</p>',
                        okText: '是',
                        cancelText: '否',
                        onOk: () => {
                          store.dispatch('PositioningDeviceInfoServ_ReopeningState', {
                            params: {
                              id: params.row.positioningDeviceInfo.id
                            },
                            urlparams: null
                          }).then(res => {
                            console.log(res)
                            this.$Message.success('重新开通成功')
                            this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            console.log(err)
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {

                        }
                      })
                    }
                  }
                }, '重新开通')
              )
            }

            if (!params.row.fileReady && params.row.serviceDatetime) {
              if (params.row.renewalOrderType == 1) {
                if (params.row.changeSim == null) {
                  display.push(
                    h('Button', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      on: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '<p>确认是否换卡</p>',
                            okText: '是',
                            cancelText: '否',
                            onOk: () => {
                              // 创建维修单
                              store.dispatch('RenewalOrderServ_ChangeSim', {
                                params: {
                                  id: params.row.id,
                                  changesim: true
                                },
                                urlparams: null
                              }).then(res => {
                                this.$Message.success('确认换卡')
                                this.refreshPage(this.pageFilter)
                              }).catch(err => {
                                console.log(err)
                                this.$Message.error(err)
                              })
                            },
                            onCancel: () => {
                              // 检测旧卡是否上线
                              store.dispatch('RenewalOrderServ_ChangeSim', {
                                params: {
                                  id: params.row.id,
                                  changesim: false
                                },
                                urlparams: null
                              }).then(res => {
                                this.$Message.success('确认不换卡')
                                this.refreshPage(this.pageFilter)
                              }).catch(err => {
                                console.log(err)
                                this.$Message.error(err)
                              })
                            }
                          })
                        }
                      }
                    }, '是否换卡')
                  )
                }
                if (params.row.changeSim == false) {
                  display.push(
                    h('Tag', {
                      props: {
                        size: 'medium',
                        type: 'dot',
                        color: 'warning'
                      }
                    }, '不换卡')
                  )
                }
                if (params.row.maintainOrder != null) {
                  if (params.row.maintainOrder.state == 3) {
                    //  维修已完成
                    display.push(
                      h('Tag', {
                        props: {
                          size: 'medium',
                          type: 'dot',
                          color: 'success'
                        }
                      }, '维修完成')
                    )
                  }
                  if (params.row.maintainOrder.state != 3 && params.row.maintainOrder.state != 0) {
                    //  维修中
                    display.push(
                      h('Tag', {
                        props: {
                          size: 'medium',
                          type: 'dot',
                          color: 'warning'
                        }
                      }, '维修中')
                    )
                  }
                }
              }

              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: '提示',
                        content: '<p>确认准备资料完成</p>',
                        onOk: () => {
                          store.dispatch('RenewalOrderServ_ConfirmFileReady', { params: { id: params.row.id } }).then(() => {
                            this.$Message.success('确认成功')
                            this.setDatetimeModal = true
                            this.setDatetimeId = params.row.positioningDeviceInfo.id
                            this.exportDatetime = new Date()
                            if (params.row.positioningDeviceInfo.setupDatetime) {
                              this.installDatetime = new Date(params.row.positioningDeviceInfo.setupDatetime)
                            } else {
                              this.installDatetime = new Date()
                            }
                            this.setDatetimeModal = true
                            this.adas = params.row.positioningDeviceInfo.positioningDeviceModel.adas
                            if (this.adas) {
                              if (params.row.userGroupId == 1) {
                                this.setVideoDatetimeModal = true
                              }
                            } else {
                              this.setMergencyAlarmModal = true
                            }
                            // this.$Modal.confirm({
                            //   title: '是否需要导出应急报警装置安装证明',
                            //   onOk: () => {
                            //     this.setMergencyAlarmModal = true
                            // },
                            // onCancel: () => {
                            // }
                            // })
                            this.refreshPage(this.pageFilter)
                          }).catch(err => {
                            this.$Message.error(err)
                          })
                        },
                        onCancel: () => {
                        }
                      })
                    }
                  }
                }, '资料准备完成')
              )

              display.push(h('Dropdown',
                {
                  props: {
                    transfer: true
                  }
                },
                [h('Button', '更多'),
                  h('DropdownMenu', {
                    slot: 'list'
                  }, [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.changeBusinessUserId = params.row.id
                          this.changeBusinessUserModal = true
                        }
                      }
                    }, '指派业务员'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.$Modal.confirm({
                            title: '提示',
                            content: '<p>确认准备资料完成</p>',
                            onOk: () => {
                              store.dispatch('RenewalOrderServ_ConfirmFileReady', { params: { id: params.row.id } }).then(() => {
                                this.$Message.success('确认成功')
                                this.setDatetimeModal = true
                                this.setDatetimeId = params.row.positioningDeviceInfo.id
                                this.exportDatetime = new Date()
                                if (params.row.positioningDeviceInfo.setupDatetime) {
                                  this.installDatetime = new Date(params.row.positioningDeviceInfo.setupDatetime)
                                } else {
                                  this.installDatetime = new Date()
                                }
                                this.setDatetimeModal = true
                                this.adas = params.row.positioningDeviceInfo.positioningDeviceModel.adas
                                if (this.adas) {
                                  if (params.row.userGroupId == 1) {
                                    this.setVideoDatetimeModal = true
                                  }
                                }
                                // this.refreshPage(this.pageFilter)
                              }).catch(err => {
                                this.$Message.error(err)
                              })
                            },
                            onCancel: () => {
                            }
                          })
                        }
                      }
                    }, '确认资料'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.addToRemarkId = params.row.id
                          this.addToRemarkModal = true
                        }
                      }
                    }, '追加备注'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.handleSelectAll(false)
                          this.renewalOrderRefuseServiceId = params.row.id
                          this.renewalOrderRefuseServiceModal = true
                        }
                      }
                    }, '拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmRefuseServiceId = params.row.id
                          this.renewalOrderConfirmRefuseServiceModal = true
                        }
                      }
                    }, '确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCallbackClientId = params.row.id
                          this.renewalOrderCallbackClientModal = true
                        }
                      }
                    }, '回访确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCancelId = params.row.id
                          this.renewalOrderCancelModal = true
                        }
                      }
                    }, '作废')
                  ])
                ])
              )
            } else if (!params.row.fileReady && !params.row.serviceDatetime) {
              display.push(
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.handleSelectAll(false)
                      this.checkRenewalOrder(params.row.id)
                    }
                  }
                }, '确认到费期')
              ),
              display.push(h('Dropdown',
                {
                  props: {
                    transfer: true
                  }
                },
                [h('Button', '更多'),
                  h('DropdownMenu', {
                    slot: 'list',
                    transfer: true
                  }, [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false,
                        transfer: true
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.changeBusinessUserId = params.row.id
                          this.changeBusinessUserModal = true
                        }
                      }
                    }, '指派业务员'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.addToRemarkId = params.row.id
                          this.addToRemarkModal = true
                        }
                      }
                    }, '追加备注'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmReceptId = params.row.id
                          this.renewalOrderConfirmReceptModal = true
                        }
                      }
                    }, '确认收款'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.handleSelectAll(false)
                          this.renewalOrderRefuseServiceId = params.row.id
                          this.renewalOrderRefuseServiceModal = true
                        }
                      }
                    }, '拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmRefuseServiceId = params.row.id
                          this.renewalOrderConfirmRefuseServiceModal = true
                        }
                      }
                    }, '确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCallbackClientId = params.row.id
                          this.renewalOrderCallbackClientModal = true
                        }
                      }
                    }, '回访确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCancelId = params.row.id
                          this.renewalOrderCancelModal = true
                        }
                      }
                    }, '作废')
                  ])])
              )
            } else {
              display.push(h('Dropdown',
                {
                  props: {
                    transfer: true
                  }
                },
                [h('Button', '更多'),
                  h('DropdownMenu', {
                    slot: 'list',
                    transfer: true
                  }, [
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false,
                        transfer: true
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.changeBusinessUserId = params.row.id
                          this.changeBusinessUserModal = true
                        }
                      }
                    }, '指派业务员'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false,
                        transfer: true
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmServiceDatetimeId = params.row.id
                          this.renewalOrderConfirmServiceDatetimeModal = true
                        }
                      }
                    }, '修改到费期'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.addToRemarkId = params.row.id
                          this.addToRemarkModal = true
                        }
                      }
                    }, '追加备注'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmReceptId = params.row.id
                          this.renewalOrderConfirmReceptModal = true
                        }
                      }
                    }, '确认收款'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.handleSelectAll(false)
                          this.renewalOrderRefuseServiceId = params.row.id
                          this.renewalOrderRefuseServiceModal = true
                        }
                      }
                    }, '拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderConfirmRefuseServiceId = params.row.id
                          this.renewalOrderConfirmRefuseServiceModal = true
                        }
                      }
                    }, '确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCallbackClientId = params.row.id
                          this.renewalOrderCallbackClientModal = true
                        }
                      }
                    }, '回访确认拒绝服务'),
                    h('DropdownItem', {
                      props: {
                        type: 'primary',
                        size: 'small',
                        disabled: false
                      },
                      style: {
                        marginRight: '5px'
                      },
                      nativeOn: {
                        click: () => {
                          this.renewalOrderCancelId = params.row.id
                          this.renewalOrderCancelModal = true
                        }
                      }
                    }, '作废')
                  ])])
              )
            }
            //
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.addToRemarkId = params.row.id
            //         this.addToRemarkModal = true
            //       }
            //     }
            //   }, '追加备注')
            // )
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.vehicleInfoDetailId = params.row.positioningDeviceInfo.vehicleInfoId
            //         this.vehicleInfoDetailModal = true
            //       }
            //     }
            //   }, '车辆信息')
            // )
            //
            // if (params.row.state === 1) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.checkRenewalOrder(params.row.id)
            //         }
            //       }
            //     }, '确认服务期')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderRefuseServiceId = params.row.id
            //           this.renewalOrderRefuseServiceModal = true
            //         }
            //       }
            //     }, '拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCancelId = params.row.id
            //           this.renewalOrderCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 2) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderConfirmServiceDatetimeId = params.row.id
            //           this.renewalOrderConfirmServiceDatetimeModal = true
            //         }
            //       }
            //     }, '更改服务期')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderConfirmReceptId = params.row.id
            //           this.renewalOrderConfirmReceptModal = true
            //         }
            //       }
            //     }, '确认收款')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderRefuseServiceId = params.row.id
            //           this.renewalOrderRefuseServiceModal = true
            //         }
            //       }
            //     }, '拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCancelId = params.row.id
            //           this.renewalOrderCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 3) {
            //
            // } else if (params.row.state === 4) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.checkRenewalOrder(params.row.id)
            //         }
            //       }
            //     }, '确认服务期')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCallbackClientId = params.row.id
            //           this.renewalOrderCallbackClientModal = true
            //         }
            //       }
            //     }, '回访确认拒绝服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCancelId = params.row.id
            //           this.renewalOrderCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 5) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderConfirmRefuseServiceId = params.row.id
            //           this.renewalOrderConfirmRefuseServiceModal = true
            //         }
            //       }
            //     }, '停止服务')
            //   )
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.renewalOrderCancelId = params.row.id
            //           this.renewalOrderCancelModal = true
            //         }
            //       }
            //     }, '作废')
            //   )
            // } else if (params.row.state === 6) {
            //   display.push(
            //     h('Button', {
            //       props: {
            //         type: 'primary',
            //         size: 'small',
            //         disabled: false
            //       },
            //       style: {
            //         marginRight: '5px'
            //       },
            //       on: {
            //         click: () => {
            //           this.$Modal.confirm({
            //             title: '提示',
            //             content: '<p>确认重新开通服务</p>',
            //             okText: '是',
            //             cancelText: '否',
            //             onOk: () => {
            //               store.dispatch('PositioningDeviceInfoServ_ReopeningState', {
            //                 params: {
            //                   id: params.row.positioningDeviceInfo.id
            //                 },
            //                 urlparams: null
            //               }).then(res => {
            //                 console.log(res)
            //                 this.$Message.success('重新开通成功')
            //                 this.refreshPage(this.pageFilter)
            //               }).catch(err => {
            //                 console.log(err)
            //                 this.$Message.error(err)
            //               })
            //             },
            //             onCancel: () => {
            //
            //             }
            //           })
            //         }
            //       }
            //     }, '重新开通')
            //   )
            // } else if (params.row.state === 0) {
            //
            // } else if (params.row.state === -1) {
            //
            // }
            //
            // display.push(
            //   h('Button', {
            //     props: {
            //       type: 'primary',
            //       size: 'small',
            //       disabled: false
            //     },
            //     style: {
            //       marginRight: '5px'
            //     },
            //     on: {
            //       click: () => {
            //         this.changeBusinessUserId = params.row.id
            //         this.changeBusinessUserModal = true
            //       }
            //     }
            //   }, '指派业务员')
            // )

            return h('div', display)
          }
        }
      ], // cloumn

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null
    }// return
  }, // data
  methods: {
    ...mapActions([
      'RenewalOrderServ_GetPage'
    ]),
    /**
     * 批量选择功能
     */
    onselectionchange (selection) {
      // console.log(selection)
      this.orderList = selection
      if (selection.length > 0) {
        selection.forEach(item => {
          this.orderIds.push(item.id)
        })
      } else {
        this.orderIds = []
      }
      // console.log(this.installOrderList.length)
    },
    handleSelectAll (status) {
      console.log(status)
      this.$refs.table.selectAll(status)
    },
    /**
     * 导出证明
     */
    onexportvehiclecertOk () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 1
      // if (this.certificateArea == 2) {
      // window.location.href = '/api/im/positioningdeviceinfo/generatecertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      // }else {
      // PDF文档
      window.location.href = '/api/im/positioningdeviceinfo/generatecertificateforyiliu/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
      // }
      this.refreshPage(this.pageFilter)
    },
    onOkVideo () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 1
      let adas = this.adas
      // if (this.certificateArea == 2) {
      // window.location.href = '/api/im/positioningdeviceinfo/generatevideocertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + adas
      // }else {
      // PDF文档
      window.location.href = '/api/im/positioningdeviceinfo/generatevideocertificateforyiliu/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType + '/' + adas
      // }
    },
    /**
     * 导出应急报警证明
     */
    onOkMergencyAlarm () {
      let setupDatetime = this.installDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let exportDatetime = this.exportDatetime.Format('yyyy-MM-dd hh:mm:ss')
      let effectiveType = 1
      window.location.href = '/api/im/positioningdeviceinfo/generateemergencyalarmcertificate/' + this.setDatetimeId + '/' + this.certificateArea + '/' + setupDatetime + '/' + exportDatetime + '/' + effectiveType
    },
    /**
       * 表格右键回调
       */
    onTableRightClick (e) {
      this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
    },
    /**
       * 右键菜单点击回调
       */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    },
    onSuccess () {
      this.setPage(1)
    },
    onModifySuccess () {
      this.refreshPage(this.pageFilter)
    },
    onColumnUpdate () {
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '跟进业务员') {
          this.columns[i].filters = this.marketsales
          break
        }
      }
      for (let i = 0; i < this.columns.length; i++) {
        if (this.columns[i].title === '销售渠道') {
          this.columns[i].filters = this.allSalesChannels
          break
        }
      }
    },
    // 手动分析续费订单
    onManualAnalysis () {
      this.renewalOrderBatchManualModal = true
    },
    onExportExcel () {
      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('createDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6),
          genQueryParam('state', 'EQ', 7)]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.isfreeFilter) {
        qo4 = this.isfreeFilter
      } else {
        qo4 = genQueryParam('isfree', 'EQ', 1)
      }
      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }
      let urlparams = {
        qo1: qo1,
        qo2: qo2,
        qo3: qo3,
        qo4: qo4,
        q: queryParams,
        keyword: this.keywordFilter
      }
      let url = '/api/om/renewalorder/getteamreport' + genURLParams(urlparams)
      window.location.href = url
    },
    onFilterClick () {
      this.FilterClickFilter = null
      this.setPage(1)
    },
    DropdownonFilterClick (name) {
      if (name != null) {
        this.FilterClickFilter = name
        this.setPage(1)
      }
    },
    DropdownonBitchClick (name) {
      if (name != null) {
        if (name == 'ConfirmServiceDatetime') {
          console.log('批量确认到费期')
          this.renewalOrderConfirmServiceDatetimeModal = true
        } else if (name == 'RefuseService') {
          console.log('批量拒绝服务')
          this.renewalOrderRefuseServiceModal = true
        }
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage(this.pageFilter)
    },
    checkRenewalOrder (renewalOrderId) {
      store.dispatch('Jt808ServCombineOrderServ_CheckRenewalOrder', {
        params: { renewalOrderId: renewalOrderId },
        urlparams: null
      }).then(() => {
        let rData = store.getters.get_Jt808ServCombineOrder_CheckRenewalOrderResult
        if (rData.result) {
          this.$Modal.confirm({
            title: '提示',
            content: '<p>该续费订单需要转换成合拼部标服务订单</p>',
            onOk: () => {
              this.renewalToJt808ServCombineModal = true
              this.renewalToJt808ServCombineModalId = renewalOrderId
              this.renewalToJt808ServCombineModalDeviceSource = rData.deviceSource
            },
            onCancel: () => {

            }
          })
        } else {
          this.renewalOrderConfirmServiceDatetimeId = renewalOrderId
          this.renewalOrderConfirmServiceDatetimeModal = true
        }
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let qo3 = null
      let qo4 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      } else {
        sortParam = genSortParam('updateDatetime', false)
      }
      if (this.stateFilter) {
        qo1 = this.stateFilter
      } else {
        qo1 = [genQueryParam('state', 'EQ', 1),
          genQueryParam('state', 'EQ', 2),
          genQueryParam('state', 'EQ', 3),
          genQueryParam('state', 'EQ', 4),
          genQueryParam('state', 'EQ', 5),
          genQueryParam('state', 'EQ', 6),
          genQueryParam('state', 'EQ', 7)]
      }
      if (this.receptFilter) {
        queryParams.push(this.receptFilter)
      }
      if (this.fileReadyFilter) {
        queryParams.push(this.fileReadyFilter)
      }
      if (this.businessUserFilter) {
        qo2 = this.businessUserFilter
      }
      if (this.billTypeFilter) {
        qo3 = this.billTypeFilter
      }
      if (this.isfreeFilter) {
        qo4 = this.isfreeFilter
      } else {
        qo4 = genQueryParam('isfree', 'EQ', 1)
      }
      if (this.selectServiceDatetime[0] && this.selectServiceDatetime[1]) {
        let startDatetime = new Date(this.selectServiceDatetime[0]).Format('yyyy-MM-dd 00:00:00')
        let endDatetime = new Date(this.selectServiceDatetime[1]).Format('yyyy-MM-dd 23:59:59')
        if (this.FilterClickFilter != null) {
          queryParams.push(genQueryParam(this.FilterClickFilter, 'BTDT', startDatetime, endDatetime))
        } else {
          queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
        }
      }

      store.dispatch('RenewalOrderServ_GetMyUserGroupPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          qo3: qo3,
          qo4: qo4,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        console.log('err')
        this.$Message.error(err)
      })
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onTest () {
      store.dispatch('RenewalOrderServ_OmTest', {
        params: null,
        urlparams: null
      }).then(() => {
        this.$Message.success('测试')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    // computeCol() {
    //   let columns = this.columns
    //   columns = columns.filter(col => {
    //     for (var i = 0; i < this.columnsDisplay.length; i++) {
    //       if (this.columnsDisplay[i] === col.title) {
    //         return true
    //       }
    //     }
    //     return false
    //   })
    //   return columns
    // },
    totalElements () {
      if (store.getters.get_RenewalOrder_GetMyUserGroupPageResult) {
        return store.getters.get_RenewalOrder_GetMyUserGroupPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_RenewalOrder_GetMyUserGroupPageResult) {
        return store.getters.get_RenewalOrder_GetMyUserGroupPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_RenewalOrder_GetMyUserGroupPageResult) {
        return store.getters.get_RenewalOrder_GetMyUserGroupPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // this.columns.forEach(item => {
      //   this.columnHeaders.push(item.title)
      //   this.columnsDisplay.push(item.title)
      // })
      store.dispatch('UserServ_GetAllUsers', {
        params: {},
        urlparams: { roleIds: [8] }
      }).then(() => {
        let renewalers = store.getters.get_User_GetAllUsersResult
        this.renewalers = renewalers.map(item => {
          return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
        })
        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [7] }
        }).then(() => {
          let marketsales = store.getters.get_User_GetAllUsersResult
          this.marketsales = marketsales.map(item => {
            return { label: item.realName != null ? item.realName : item.nickName != null ? item.nickName : item.name, value: item.id }
          })
          // this.columns[4].filters = this.renewalers
          // this.columns[11].filters = this.marketsales
          store.dispatch('SalesChannelServ_GetAll', {
            params: null,
            urlparams: null
          }).then(() => {
            let allSalesChannels = store.getters.get_SalesChannel_GetAllResult
            this.allSalesChannels = allSalesChannels.map(item => {
              return { label: item.name, value: item.id }
            })
            this.onColumnUpdate()
          }).catch(err => {
            this.$Message.error(err)
          })
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })

      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>
</style>
